module.exports = __webpack_public_path__ + "static/media/home-page-background.7a7d201b.jpg";